module.exports = __webpack_public_path__ + "img/story017.75a62e99.png";